import { getRecaptchaToken } from "@/utils/recaptcha";
import { useCallback } from "react";
import { useAccount } from "wagmi";
import { BLOCK_EXPLORER_URL, PAYMENT_API_PATH } from "../../constants";
import type { PaymentFormValues } from "../PaymentForm";
import usePrices from "./usePrices";

export default function useRegisterPayment() {
  const { address } = useAccount();
  const { halfEthInKolz } = usePrices();

  const registerPayment = useCallback(
    async (data: PaymentFormValues, paymentMethod: "eth" | "kolz", transactionId: string) => {
      const recaptchaTokenForPayment = await getRecaptchaToken("submit");
      const postResponse = await fetch(`${PAYMENT_API_PATH}/new`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: paymentMethod,
          transactionUrl: `${BLOCK_EXPLORER_URL}/tx/${transactionId}`,
          totalAmount: paymentMethod === "eth" ? 1 : Math.floor(halfEthInKolz),
          recaptchaToken: recaptchaTokenForPayment,
          user: {
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            telegramHandle: data.telegramId,
            walletAddress: address,
            mobilePhone: data.mobilePhone,
          },
        }),
      });

      if (!postResponse.ok) {
        throw new Error("Error registering the payment");
      }
    },
    [address, halfEthInKolz],
  );

  return { registerPayment };
}
